module.exports = __webpack_public_path__ + "img/active_1.a57edb40.png";